import React from 'react';
import CircularButtonGroup from '../../../../../../_components/common/CircularButtonGroup'
import Radarcharts from '../../../../../../_components/common/Charts/RadarCharts'
import ModularTooltip from '../../../../../../_components/common/ModularTooltip'

import rightMark from '../../../../../../images/right_mark.png'

import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';

import './index.css'

class FocusAreaParameters extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isTooltipOpen: false,
            selectedDivData: null,
        }
    }

    

    render() {
        const { data, buttonGroupData, orientcategory, heading, headingProp, mainData } = this.props;
    return (
        <div className={this.props.orientationLvl ? "d-flex col-12 mt-1 px-0 align-items-center" : "d-flex col-12 mt-1 px-0"}>
            <div className="col-8 pt-3">
                {
                    mainData.header == '' ?
                        null :
                        <h5 className="font-weight-bold text-center">{mainData.header}</h5>
                }
                <Radarcharts heading={mainData.header} orientationLvl={this.props.orientationLvl} graphData={this.props.graphData}/>
            </div>
            <div className="d-flex flex-column col-4 px-0">
                <div className="d-flex align-items-center fle-row focus-area-param-heading">
                    {
                        headingProp ?
                            null :
                            <div className="">
                                <CircularButtonGroup buttonGroupData={buttonGroupData} swotCatagory={orientcategory == undefined ? 0 : orientcategory} singleButton={true} uncontrolledButton={true} toolTip={false}/>
                            </div>
                    }
                    <div className="">
                        <small className="font-weight-bold font-italic">{heading}</small>
                    </div>
                </div>
                {
                    headingProp ?
                        <div className="d-flex focus-area-param-card-header align-items-center pl-5" style={{ backgroundImage: `url(${mainData.icon})`, backgroundPosition: 'center', backgroundSize: 'cover'  }}>
                            {/* <div className="pl-5"></div> */}
                            <h6 className="ml-3 mb-0 px-1 font-weight-bold">{mainData.header}</h6>
                        </div>
                        :
                        null
                }
                {
                    data.length ?
                        this.props.showAllFocusAreas ?
                            data.map((val, key) => {
                                return (
                                    <PopOverCustom headingProp={headingProp} val={val} />
                                )
                            })
                        :
                            [data[0]].map((val, key) => {
                                return (
                                    <PopOverCustom headingProp={headingProp} val={val} />
                                )
                            })
                    :
                        null
                }
            </div>
        </div>
    );
    }
}

class PopOverCustom extends React.Component {

    constructor(props) {
        super(props);
    
        this.showActionItems = this.showActionItems.bind(this);
        this.state = {
            showActionItem: false
        };
    }

    showActionItems() {
        this.setState({
            showActionItem: !this.state.showActionItem
        })
    }

    render() {
        const {val, headingProp} = this.props;
        return (
            <div>
                <div className="focus-area-param-card-child-text text-left m-1 py-2" style={{ backgroundImage: val.background_color, paddingLeft: 20, paddingRight: 20,cursor: "pointer" }} >
                    <div id={`TooltipExample${`${val.name}`.replace(/\s/g, '')}`}>
                        <p className="pt-3 mb-2" style={{ fontSize: 16, fontWeight: 'bold' }}>{val.name}</p>
                        <p className="mb-2" style={{ fontSize: 14, fontWeight: "normal" }}>{val.discription}</p>
                        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                            <div>
                                {
                                    headingProp &&
                                        <p className="font-weight-bold font-italic footer_text_p">{(val.footer_text)}</p>
                                }
                            </div>
                            {
                                val.act_now &&
                                    <div className="act_now" onClick={() => {
                                        // this.showActionItems()
                                    }}><p style={{margin: 0}}>ACT NOW</p></div>
                            }
                        </div>
                        <Popover hideArrow={true} width={300} style={{borderRadius: 0}} placement="bottom" isOpen={this.state.showActionItem} target={`TooltipExample${`${val.name}`.replace(/\s/g, '')}`} toggle={this.showActionItems}>
                            <PopoverHeader style={{borderRadius: 0, background: '#b3b3b3', padding: '0.6rem 2.4rem'}}>
                                <div className="popover-heading-div">
                                    <p>{val.name}: Action items</p>
                                    <i className="fa fa-times mb-0 float-right py-2" onClick={this.showActionItems} style={{ cursor: "pointer" }}></i>
                                </div>
                            </PopoverHeader>
                            <PopoverBody>
                                <div className="popover-body-div">
                                    <div style={{padding: '0 1.4rem'}}>
                                        <div>
                                            <p className="font-italic" style={{fontSize: 12, margin: 0}}>Ability to express opinions and ideas freely to the team members</p>
                                        </div>
                                        <div>
                                            <p className="font-italic font-weight-bold" style={{fontSize: 10}}>{val.footer_text}</p>
                                        </div>
                                    </div>
                                    <div className="popover-body-data ">
                                        <img src={rightMark} style={{width: 26, height: 20}} />
                                        <p className="font-weight-bold">Ensure you keep your learning ongoing and learn a new technique every week.</p>
                                    </div>
                                    <div className="popover-body-data">
                                        <img src={rightMark} style={{width: 26, height: 20}} />
                                        <p className="font-weight-bold">Take interest in understanding your team
                                        mates better and their core motivations and
                                        likes.</p>
                                    </div>
                                    <div className="popover-body-data">
                                        <img src={rightMark} style={{width: 26, height: 20}} />
                                        <p className="font-weight-bold">Keep yourself abreast with your field of work
                                        and gain as much new knowledge as
                                        possible.</p>
                                    </div>
                                    <div className="popover-body-data">
                                        <img src={rightMark} style={{width: 26, height: 20}} />
                                        <p className="font-weight-bold">Actively participate in team events and show
                                        your support to relates causes.</p>
                                    </div>
                                </div>
                            </PopoverBody>
                        </Popover>
                    </div>
                    {/* <ModularTooltip data={val}/> */}
                </div>
            </div>
        )
    }
}

export default FocusAreaParameters


// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/Category/FocusArea/FocusAreaParameters/index.js